import { LoadState } from "../../constants/enums";

import { initialCustomerFullDetailsState } from "./allCustomers.types";
import { createSlice } from "@reduxjs/toolkit";
import { fetchAllCustomersList } from "./allCustomersActions";
import { APIError } from "../../constants/types";

export const allCustomersSlice = createSlice({
  name: "allCustomers",
  initialState: initialCustomerFullDetailsState,
  reducers: {
    clearAllCustomersState: (state) => {
      return initialCustomerFullDetailsState;
    },
    clearAllCustomers: (state) => {
      state.loading = LoadState.NotLoaded;
      state.list = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCustomersList.pending, (state) => {
        state.loading = LoadState.InProgress;
        state.list = [];
      })
      .addCase(fetchAllCustomersList.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.list = action.payload.data;
      })
      .addCase(fetchAllCustomersList.rejected, (state, action) => {
        state.loading = LoadState.Failed;
        state.list = [];
        state.error = (action.payload as APIError).message;
      });
  },
});

export const { clearAllCustomersState, clearAllCustomers } =
  allCustomersSlice.actions;
export const AllCustomersDetailsReducer = allCustomersSlice.reducer;
